/** 默认后端 API 域名（生产打包直连；开发走 devServer 代理） */
export const DEFAULT_REMOTE_API_ORIGIN = 'https://imovieapi.pluskeji.cn'

/**
 * API 根地址（不含末尾斜杠）
 * - 开发：默认 ''，请求走 /xxx + devServer 反代
 * - 生产：默认 DEFAULT_REMOTE_API_ORIGIN；若 Nginx 已做同源反代，在 .env.production 设 VUE_APP_API_BASE_URL=/
 */
export function getApiBaseUrl() {
  const raw = process.env.VUE_APP_API_BASE_URL
  if (raw != null && String(raw).trim() !== '') {
    const v = String(raw).trim()
    if (v === '/') return ''
    return v.replace(/\/+$/, '')
  }
  if (process.env.NODE_ENV === 'development') {
    return ''
  }
  return DEFAULT_REMOTE_API_ORIGIN
}

/** 将 /path 拼成完整 API URL；开发或未配置 base 时保持相对路径 */
export function resolveApiUrl(path) {
  const p = path && String(path).startsWith('/') ? String(path) : `/${path || ''}`
  const base = getApiBaseUrl()
  if (!base) return p
  return `${base}${p}`
}
